import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl text-center w-full mb-3" }, "切り抜き", -1)
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "card mx-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card_text text-sm lg:text-md mx-3 m-1 text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card_footer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.video_data, (video) => {
        return (_openBlock(), _createElementBlock("div", {
          key: video.title,
          class: "mb-2 sm:w-1/2 lg:w-1/4 xl:w-1/5 w-full"
        }, [
          _createElementVNode("article", _hoisted_3, [
            _createElementVNode("a", {
              href: video.url,
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _createElementVNode("figure", null, [
                _createElementVNode("img", {
                  src: video.thumbnail_url,
                  alt: "サムネ"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(video.title), 1),
              _hoisted_7
            ], 8, _hoisted_4)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}